import React from 'react';

import withNavigation from "../../higher-order/navigation.js";
import FermerEnregistrementFormBase from '../shared/fermer-enregistrement-form-base.js';
import { useFermerEnregistrementForm } from '../shared/use-fermer-enregistrement-form.js';

import { useSelector } from "react-redux";

import { PATH_FERMER_ENREGISTREMENT } from '../../../constants/navigation-constants.js';
import { buildSimpleFermeturePayload } from '../../../utils/fermer-enregistrement.js';

const FermerEnregistrementEtCapture = ({ goTo, location, language }) => {
  const { fermerEnregistrement: { idEnregistrementEntete } } = useSelector(state => state);

  const {
    TEXTS,
    calendarRef,
    date,
    load,
    heureIsSlected,
    dateIsSelected,
    setdateIsSelected,
    isOpenCalendar,
    setIsOpenCalendar,
    enregistrementEntete,
    dateErrorKey,
    minSelectableDate,
    maxSelectableDate,
    authToken,
    handleDateChange,
    handleTimeChange,
    submitFermeture,
  } = useFermerEnregistrementForm({
    location,
    idEnregistrementEntete,
    language,
  });

  const navigation = async () => {
    if (authToken) {
      const result = await submitFermeture((decodedToken, dateFermetureISO) =>
        buildSimpleFermeturePayload({
          idProfile: decodedToken.idProfile,
          dateFermetureISO,
          idEnregistrementEntete: enregistrementEntete,
        })
      );
      if (result) {
        goTo(PATH_FERMER_ENREGISTREMENT);
      }
    }
  };

  const showSubmit = dateIsSelected && heureIsSlected;

  return (
    <FermerEnregistrementFormBase
      texts={TEXTS}
      goTo={goTo}
      location={location}
      isLoading={load}
      loadError=""
      enregistrementEntete={enregistrementEntete}
      dataLoading={false}
      calendarRef={calendarRef}
      date={date}
      isOpenCalendar={isOpenCalendar}
      setIsOpenCalendar={setIsOpenCalendar}
      setdateIsSelected={setdateIsSelected}
      minSelectableDate={minSelectableDate}
      maxSelectableDate={maxSelectableDate}
      dateErrorKey={dateErrorKey}
      handleDateChange={handleDateChange}
      dateIsSelected={dateIsSelected}
      handleTimeChange={handleTimeChange}
    >
      {showSubmit &&
        <button
          onClick={() => navigation()}
          className="fermer-enregistrement-button"
        >
          <span className="droit-acces-span">{TEXTS.closeButton}</span>
        </button>
      }
    </FermerEnregistrementFormBase>
  );
};

export default withNavigation(FermerEnregistrementEtCapture);
